'use strict';

import Api from "./Api";

export default class ClientCard extends Api {

    static get(id) {
        const url = this.url + 'client-card/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'client-card/add';

        return this.getAxios().post(url, data);
    }

}